<template>
  <div class="Applyfor">
    <!-- 用车申请列表 -->
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="nav" @click="detailsClick(item)" v-for="(item, index) in list" :key="index" :title="item">
        <div class="mr">
          <!-- 1, "审批中"  2, "审批通过" 3,"审批失败" 4,"已分配" 5,"已完成" 6,"已取消"-->
          <span class="have" style="margin-right: 8px">
            {{
              useTypeList[item.useType - 1]
            }}
          </span>
          <!-- 用车状态 -->
          <span :class="item.applyState == '6'
            ? 'cancellation'
            : item.applyState == '5'
              ? 'complete'
              : item.applyState == '3'
                ? 'have'
                : item.applyState == '1'
                  ? 'colorBlue'
                  : item.applyState == '2'
                    ? 'complete'
                    : item.applyState == '7'
                      ? 'cancellation'
                      : ''
            ">
            {{
              item.applyState == "6"
                ? "已取消"
                : item.applyState == "5"
                  ? "已完成"
                  : item.applyState == "3"
                    ? "审批失败"
                    : item.applyState == "1"
                      ? "审批中"
                      : item.applyState == "2"
                        ? "审批通过"
                        : item.applyState == "7"
                          ? "已作废"
                          : ""
            }}
          </span>
        </div>
        <div class="allotPlace">
          <div class="allotPlaceItems">
            <div class="place">{{ item.airportName }}</div>
          </div>
          <div style="text-align: center" class="line">
            <img src="@/assets/car/arrows.png" alt="" />
          </div>
          <div class="allotPlaceItems1">
            <div class="place" v-for="(i, int) in item.addressInfoList" :key="int">{{ i.useLocation }}</div>
          </div>

        </div>
        <!-- <div v-if="item.addressInfoList.length > 0" class="address mr">
          <span>途径：</span>
          <span v-for="(itemadderss, index) in item.addressInfoList" :key="index">
            {{ itemadderss.useLocation }}
            <span v-show="item.addressInfoList.length !== index + 1">,</span>
          </span>
        </div> -->
        <div class="font flex mr">
          <span>用车人数：{{ item.useNumber }}人</span>
        </div>
        <div class="font mr">
          <span>预约时间：</span>
          <span>{{ comfirmArriveTime(item.useSaterTime) }}</span>
        </div>
        <div class="bd mr"></div>
        <div v-if="item.applyState == '1' ||
          item.applyState == '2' ||
          item.applyState == '3' ||
          item.applyState == '4' || item.applyState == '6'
        " class="btn">
          <div class="itemsBtnLeft" v-if="item.applyState == '1' ||
            item.applyState == '2' ||
            item.applyState == '3' ||
            item.applyState == '4'
          ">
            <van-button type="default" size="small" @click.stop="close(item)">{{
              item.type == "同行人" ? "取消同行" : "取消预约"
            }}</van-button>
          </div>
          <div v-show="item.type != '同行人'" class="itemsBtnRight" v-if="$route.query.isShowTabs == 'false'">
            <van-button type="default" size="small" @click.stop="editCarDetail(item)">修改</van-button>
          </div>
          <div v-if="item.applyState == '6'" class="itemsBtnRightRed">
            <van-button type="default" size="small" @click.stop="delectCarDetail(item)">删除</van-button>
          </div>
          <div v-if="item.applyState == '6'" class="itemsBtnRight">
            <van-button type="default" size="small" @click.stop="submitApproval(item)">重新提交</van-button>
          </div>
        </div>
        <div v-else-if="item.useState == '3'">
          <span style="margin-right: 10px;">里程金额：{{ item.travelCost }}元</span>
          <span style="margin-right: 10px;">路桥费：{{ item.roadBridgeCost }}元</span>
          <span style="margin-right: 10px;">用车费用：{{ item.totalCost }}元</span>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import moment from "moment";
import "moment/locale/zh-cn";
import apis from "@/apis/car.js";
export default {
  name: "Applyfor",
  props: {},
  components: {},
  data() {
    return {
      list: [],
      listdemo: [],
      loading: false,
      finished: false,
      page: 1,
      pageSize: 20,
      totalAll: 0,
      useTypeList: ["客户接待", "接机", '送机', "供应商考察", "其他"],
    };
  },
  created() { },
  mounted() {
  },
  methods: {
    //  时间
    comfirmArriveTime(value) {
      return moment(value).format("MM月DD日 dddd HH:mm");
    },
    //修改
    editCarDetail(item) {
      console.log(item);
      this.$router.push({
        path: "/car/official/appointmentCarApply",
        query: {
          applyNumber: item.applyNumber //newlyAdded modify
        }
      });
    },
    // 删除
    delectCarDetail(item) {
      console.log('item', item);
      this.$dialog
        .confirm({
          message: `您确定要删除吗？`
        })
        .then(() => {
          apis
            .deleteFlow({ id: item.id })
            .then(res => {
              if (res.code == "200") {
                this.onsearch();
                // this.onLoad();
              }
            })
            .catch(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          // on cancel
        });

    },
    // 重新提交审批
    submitApproval(item) {
      this.$dialog
        .confirm({
          message: `您确定要重新提交审批吗？`
        })
        .then(() => {
          apis
            .submitApprovalApi({ id: item.id })
            .then(res => {
              if (res.code == "200") {
                console.log("重新提交审批成功", res);
                this.onsearch();
                // this.onLoad();
              }

            })
            .catch(() => {
              this.$toast.fail('重新提交审批失败');
            });
        })
        .catch(() => {
          // on cancel
        });

    },
    //取消
    close(item) {
      console.log("item", item);
      this.$dialog
        .confirm({
          message: `确定${item.type == "同行人" ? "取消同行" : "取消预约"}吗？`
        })
        .then(() => {
          let obj = {
            applyNumber: item.applyNumber,
            type: item.type,
            id: item.id
          };
          apis
            .cancelReservation(obj)
            .then(res => {
              console.log("取消同行", res);
              if (res.code == "200") {
                this.onsearch();
                this.onLoad();
              }
            })
            .catch(() => {
              this.loading = false;
            });
          // if (item.type != "同行人") {
          //   let obj = {
          //     applyNumber: item.applyNumber,
          //     id: item.id,
          //     applyState: 6
          //   };
          //   console.log(obj);
          //   apis
          //     .updateMyApplication(obj)
          //     .then(res => {
          //       console.log("取消预约", res);
          //       if (res.code == "200") {
          //         this.onsearch();
          //       }
          //     })
          //     .catch(() => {
          //       this.loading = false;
          //     });
          // } else {

          // }
        })
        .catch(() => {
          // on cancel
        });
    },
    //重置数据
    onsearch() {
      this.loading = false;
      this.finished = false;
      this.page = 1;
      this.pageSize = 20;
      this.totalAll = 0;
      this.list = [];
      // this.queryList();
    },
    //用车申请列表
    onLoad() {
      this.queryList();
    },
    // 查询列表
    queryList() {
      let obj = {
        page: this.page,
        pageSize: this.pageSize,
        zoneId: localStorage.getItem('cityId')
      };
      console.log('this.page1111111', this.page);
      apis
        .queryMyApplication({ ...obj })
        .then(res => {
          console.log("我的申请列表", res);
          this.totalAll = res.data.total;
          this.finished = false;
          console.log('this.page2222222', this.page);
          if (this.page === 1) {
            this.list = res.data.list;
          } else {
            this.list = this.list.concat(res.data.list);
          }
          console.log('this.list.length', this.list.length, this.totalAll);
          if (this.list.length < this.totalAll) {
            this.page = this.page + 1;
          } else {
            this.finished = true;
          }

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //查看费用详情
    detailsClick(item) {
      this.$router.push({
        path: "/car/official/applyDetail",
        query: {
          applyNumber: item.applyNumber, //newlyAdded modify
        }
      });
    }
  },
  activated() {
    // this.onLoad()
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .Applyfor {
    width: 100%;
    margin: auto;
  }
}

@media screen and (min-width: 600px) {
  .Applyfor {
    width: 276px * $zoom;
    margin: auto;
  }
}

.Applyfor {
  font-size: 0.3rem;
  height: calc(100vh - 110px);
  overflow-y: auto;
  padding: 0 20px;
  border-radius: 10px;
  background-color: #f8fafb;

  &::-webkit-scrollbar {
    display: none;
  }

  .nav {
    margin: 1vh 0;
    padding: 0.3125rem;
    background-color: #fff;
    line-height: 0.6rem;

    .have {
      background-color: rgb(255 243 232);
      color: rgb(255, 142, 32);
      padding: 5px;
      border-radius: 4px;
      display: inline-block;
      width: 150px;
      text-align: center;
    }

    .complete {
      background-color: rgb(237 245 242);
      color: rgb(81 164 126);
      padding: 5px;
      border-radius: 4px;
      display: inline-block;
      width: 150px;
      text-align: center;
    }

    .colorBlue {
      padding: 5px;
      border-radius: 4px;
      display: inline-block;
      width: 150px;
      text-align: center;
      background-color: #e9f1fc;
      color: #2c76e3;
    }

    .cancellation {
      background-color: rgb(240 240 241);
      color: rgb(115 115 115);
      padding: 5px;
      border-radius: 4px;
      display: inline-block;
      width: 150px;
      text-align: center;
    }

    .mr {
      margin: 15px 0;
    }

    .allotPlace {
      display: flex;
      align-items: center;
      margin: 53px 0;

      .line {
        width: 100px;
        height: 14px;
        display: flex;
        align-items: center;
        margin: 0 18px;

        img {
          width: 100px;
          height: 14px;
        }
      }

      // .allotPlaceItems {
      //   min-width: 23%;
      //   max-width: 73%;

      //   .place {
      //     max-width: 100%;
      //     font-size: 0.35rem;
      //     font-weight: 600;
      //     text-overflow: -o-ellipsis-lastline;
      //     overflow: hidden;
      //     text-overflow: ellipsis;
      //     display: -webkit-box;
      //     -webkit-line-clamp: 2;
      //     line-clamp: 2;
      //     -webkit-box-orient: vertical;
      //   }
      // }

      .allotPlaceItems {
        min-width: 23%;
        max-width: 29%;

        .place {
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          font-size: 23px;
          // font-weight: bold;
        }
      }

      .allotPlaceItems1 {
        min-width: 23%;
        max-width: 87%;

        .place {
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          font-size: 23px;
          // font-weight: bold;
        }
      }
    }

    .flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .font {
      font-size: 0.35rem;
      font-weight: 600;
      color: #27394e;
    }

    // .line {
    //   width: 128px;
    //   height: 14px;
    //   display: flex;
    //   align-items: center;
    //   margin: 0 18px;

    //   img {
    //     width: 136px;
    //     height: 14px;
    //   }
    // }

    // &:last-child {
    //   .line {
    //     width: 0;
    //     height: 0;

    //     img {
    //       width: 0;
    //       height: 0;
    //     }
    //   }
    // }

    .address {
      width: 90%;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 0.35rem;
      font-weight: 600;
      color: #ccc;
    }

    .bd {
      width: 100%;
      height: 1px;
      background-color: #ccc;
    }

    .btn {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;

      .itemsBtnLeft {
        ::v-deep(.van-button--small) {
          border-radius: 10px;
          height: 50px;
          padding: 0 30px;
          background-color: #fff;
          font-size: 27px;
          color: #969b9e;
          margin-right: 10px;
        }
      }

      .itemsBtnRight {
        ::v-deep(.van-button--small) {
          border-radius: 10px;
          height: 50px;
          padding: 0 30px;
          background-color: #4ea27c;
          font-size: 27px;
          color: #fff;
        }
      }

      .itemsBtnRightRed {
        margin: 0 10px;

        ::v-deep(.van-button--small) {
          border-radius: 10px;
          height: 50px;
          padding: 0 30px;
          background-color: #e1481d;
          font-size: 27px;
          color: #fff;
        }
      }

      .btn-r {
        margin-left: 20px;
      }
    }
  }

  .line-span {
    width: 33.3%;
    display: block;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;

    img {
      width: 90%;
    }
  }
}
</style>
